<app-header></app-header>

<section class="login">
  <app-reset-password-form></app-reset-password-form>
</section>
